import { toast } from 'react-toastify'

export const launchSuccess = (message, { autoClose, theme } = {}) => toast.success(message, { autoClose: autoClose || 2000, theme })

export const launchError = (message, {autoClose, theme } = {}) => toast.error(message, { autoClose, theme })